import MemberPermissionsTag from "common/components/MemberPermissionsTag";
import MobileDetailsDrawer from "common/components/MobileDetailsDrawer";
import MobileDetailsDrawerItem from "common/components/MobileDetailsDrawer/MobileDetailsDrawerItem";
import AimfoxAvatar from "common/components/ui/AimfoxAvatar";
import { Tag } from "common/components/ui/Tag";
import { formatDate } from "common/helpers/utils";
import type { Member } from "common/types";

import { CLIENT_ACTIONS } from "../../../constants";
import ClientActions from "../ClientActions";

interface MobileDrawerContentProps {
  client: Member;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export default function MobileClientDetails({
  isOpen,
  setIsOpen,
  client,
}: MobileDrawerContentProps) {
  const {
    first_name: firstName,
    last_name: lastName,
    email,
    created_at: createdAt,
    permissions,
    role,
  } = client;

  return (
    <MobileDetailsDrawer
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      editOptions={CLIENT_ACTIONS}
      renderEditComponent={(editKey, onBack) => (
        <ClientActions
          action={editKey}
          member={client}
          onClose={() => setIsOpen(false)}
          onBack={onBack}
        />
      )}
      editTitle="Client options"
    >
      <div className="flex gap-x-2 items-start flex-1 mb-1">
        <AimfoxAvatar firstName={firstName} lastName={lastName} size="md" />

        <div className="flex flex-col gap-y-0.5">
          <span className="text-sm-bold">
            {firstName} {lastName}
          </span>
          <p className="text-black-500 text-xs-medium">{email}</p>
        </div>
      </div>

      <MobileDetailsDrawerItem label="Role">
        <MemberPermissionsTag permissions={permissions} role={role} />
      </MobileDetailsDrawerItem>
      <MobileDetailsDrawerItem label="Added">
        <Tag variant="tertiary">{formatDate(createdAt)}</Tag>
      </MobileDetailsDrawerItem>
    </MobileDetailsDrawer>
  );
}
